import React, { Component } from 'react';
import { Waypoint } from "react-waypoint";
import tinycolor from 'tinycolor2';
import * as d3 from 'd3';

import VillagerTable from '../components/VillagerTable';
import VillagerCard from '../components/VillagerCard';
import Button from '../components/Button';

import TipBubble from '../components/TipBubble';

import ChartSpecs from '../data/chart_specs';

const species = ChartSpecs.species;
const speciesOptions = [...species];
const personalities = Object.keys(ChartSpecs.chartspecs.colorWheelObjPersonality).sort((a,b)=>a.localeCompare(b));
const personalitiesOptions = [...personalities];
const hobbies = Object.keys(ChartSpecs.chartspecs.colorWheelObjHobby).sort((a,b)=>a.localeCompare(b));
const hobbiesOptions = [...hobbies];
const skincolorSegment = Object.keys(ChartSpecs.chartspecs.colorWheelObjRainbow);
const skincolorSegmentOptions = [...skincolorSegment];
const goodlookingScores = {1:"Very Strange Looking", 2:"Slightly Strange Looking", 3:"Average Looking",4:"Good Looking",5:"Very Good Looking"};
const acnhColors = ChartSpecs.chartspecs.acnhColors;


const popularSpeicesOptions = ['Bear cub', 'Cat', 'Deer', 'Dog', 'Octopus', 'Rabbit', 'Squirrel','Wolf'].sort((a,b)=>a.localeCompare(b))
const unpopularSpeicesOptions = ['Bull', 'Anteater', 'Lion', 'Mouse', 'Pig', 'Gorilla', 'Hippo', 'Kangaroo', 'Chicken', 'Cow', 'Tiger', 'Monkey'].sort((a,b)=>a.localeCompare(b))
const popularPersonalitiesOptions = ['Normal', 'Peppy', 'Lazy', 'Sisterly'].sort((a,b)=>a.localeCompare(b))
const unpopularPersonalitiesOptions = ['Snooty', 'Cranky', 'Jock', 'Smug'].sort((a,b)=>a.localeCompare(b))


popularSpeicesOptions.unshift("Select");
unpopularSpeicesOptions.unshift("Select");
popularPersonalitiesOptions.unshift("Select");
unpopularPersonalitiesOptions.unshift("Select");
skincolorSegmentOptions.unshift("Select");

class VoteEnd extends Component {
  constructor(props){
      super(props);
      //this.svgRef = React.createRef();

      let tierNodesRollup = d3.rollup(this.props.villagers, v => v.length, d => d.tier);
      this.tierArray = [...tierNodesRollup.keys()];

      // Creating the clone of the array
      let cloneVillagerData = this.props.villagers.slice(0);

      const cloneVillagerDataArr = this.props.villagers.map(d => ({ ...d}));

      // Extract the array using splice method
      this.allVillagers = cloneVillagerDataArr.splice(0,cloneVillagerDataArr.length);

      this.tierNodes = d3.groups(this.allVillagers, d => d.tier);
      this.allVillagerNodes = {};


      let fullNameList = this.allVillagers.map(v => v.name);
      let fullList = this.allVillagers;


      this.state = {
        filterType: 'positive',
        selectedVillager:'',
        cardStyle:{},
        chartWidth:this.props.chartWidth,
        filterList: [
          {
            id: 1,
            name: "Unique design",
            value: "Select",
            label: "UNIQUE",
            datalabel: "Combined_special_appearance",
            type: "checkbox",
            trend: 'positive',
            options: ['special','normal']
          },
          {
            id: 2,
            name: "No Amiibo",
            value: "Select",
            label: "AMIIBO",
            datalabel: "Amiibo",
            type: "checkbox",
            trend: 'positive',
            options: ['NO','YES']
          },
          {
            id: 8,
            name: "Very good looking",
            value: "Select",
            label: "APPEARANCE",
            datalabel: "Apperance_Score",
            type: "checkbox",
            trend: 'positive',
            options: ["Very Good Looking",'Select']
          },
          {
            id: 11,
            name: "Nature hobby",
            value: "Select",
            label: "HOBBY",
            datalabel: "hobby",
            type: "checkbox",
            trend: 'positive',
            options: ['Nature','Select']
          },
          {
            id: 3,
            name: "species",
            value: "Select",
            label: "SPECIES",
            datalabel: "species",
            type: "dropdown",
            trend: 'positive',
            options: popularSpeicesOptions
          },
          {
            id: 10,
            name: "Fitness hobby",
            value: "Select",
            label: "HOBBY",
            datalabel: "hobby",
            type: "checkbox",
            trend: 'negative',
            options: ['Fitness','Select']
          },

          {
            id: 7,
            name: "Green skin",
            value: "Select",
            label: "SKINCOLOR",
            datalabel: "colorSegment",
            type: "checkbox",
            trend: 'negative',
            options: ['green','Select']
          },

          {
            id: 9,
            name: "Very strange looking",
            value: "Select",
            label: "APPEARANCE",
            datalabel: "Apperance_Score",
            type: "checkbox",
            trend: 'negative',
            options: ["Very Strange Looking",'Select']
          },

          {
            id: 4,
            name: "species",
            value: "Select",
            label: "SPECIES",
            datalabel: "species",
            type: "dropdown",
            trend: 'negative',
            options: unpopularSpeicesOptions
          },
          {
            id: 5,
            name: "personality",
            value: "Select",
            label: "PERSONALITY",
            datalabel: "personality",
            type: "dropdown",
            trend: 'positive',
            options: popularPersonalitiesOptions
          },
          {
            id: 6,
            name: "personality",
            value: "Select",
            label: "PERSONALITY",
            datalabel: "personality",
            type: "dropdown",
            trend: 'negative',
            options: unpopularPersonalitiesOptions
          },
        ],
        filteredList: fullList,
        activeFilter: [],
        selectedFilter: {
          "UNIQUE":"Select", // 'special, normal, null'
          'AMIIBO':'Select', // 'YES, NO, null'
          'SPECIES': 'Select', // 'Cat, etc, null'
          'HOBBY':'Select', // 'Play'
          'DEBUT':'Select',
          'APPEARANCE':'Select',
          'SKINCOLOR': 'Select',
          'PERSONALITY':'Select',
          'HOUSE': 'Select', // 'special, normal, null'
        }
     };


     this.onFilterChange = this.onFilterChange.bind(this);
     this.toggleFilter = this.toggleFilter.bind(this);

     this.showCard = this.showCard.bind(this);
     this.hideCard = this.hideCard.bind(this);

  }

   componentDidMount() {
     //this.svg = d3.select(this.svgRef.current);
     //this.drawSummaryChart();
     //this.setUpVillagerThumbnail();
     //this.updateChart();
   }

   componentDidUpdate(prevProps, prevStates) {
     if (this.props.chartWidth !==  prevProps.chartWidth) {
       this.setState({
        chartWidth: this.props.chartWidth
       });
       //this.updateChart(this.state.filteredList);
     }
     //this.drawForceChart();
   }

   setUpVillagerThumbnail(){
     //// Create defs elements //////
     var defs = this.svg.append("defs");
     let chartWidth = this.state.chartWidth;
     //Create wrapper for the clip paths
     var imageWrapper = defs.append("g").attr("class", "image-group-wrapper");
     let totalVillagerNumber = this.allVillagers.length,
         radius = 4 * 5,
         allVillagers = this.allVillagers;

      //Create a circle with an image for villagers
      let defaultImageWrapper = imageWrapper.selectAll(".v-profile-image")
        .data(allVillagers)
        .join("pattern")
        //.attr("id", d => `v-profile-${d.name}`)
        .attr("id", d => {
          let imageName = d.name;
          imageName = (imageName.indexOf(' ') >= 0)?imageName.replace(/ /g,"-"):imageName;
          imageName = imageName.replace(/["']/g, "")
          return `v-profile-${imageName}`
        })
        .attr("class", "thumbnail-image v-profile-image")
        .attr("viewBox", `-${radius*0} -${radius*0} ${radius} ${radius}`)
        .attr("height", "100%")
        .attr("width", "100%")
        .attr('patternContentUnits', 'objectBoundingBox')

        defaultImageWrapper.append("circle")
          .attr("class", "v-profile-bg")
          .attr("id", d => `v-profile-bg-${d.name}`)
          .attr("fill-opacity", 0.3)
          .attr("r", radius*2)
          .attr("fill", acnhColors.themeColor)
          .style("stroke", "transparent")
          //.attr("transform", `scale(0.9) translate(${radius*0.05},${radius*0.05})`)
          .attr("transform", `scale(1) translate(${radius*0.1},${radius*0.1})`)

         defaultImageWrapper
          .append("image")
          //.attr("xlink:href", d => d.image_url)
          .attr("xlink:href", function(d,i) {
            return process.env.PUBLIC_URL + `/images/face/face-image-${d.id}.png`
            //return require(`../images/${d}.png`)
          })
          .attr('preserveAspectRatio', 'xMidYMid meet')
          .attr("transform", `translate(${radius*0.1},${radius*0.1})`)
          .attr("height", radius*0.8)
          .attr("width", radius*0.8);

    }

   updateNode(filteredList){
     const {selectedFilter} = this.state;
     let svg = this.svg,
        chartWidth = this.state.chartWidth;

     let radius = 4;

            let svgVillagerNode = svg.selectAll('.dot');

            ///const hasFilter = (Object.keys(filters).length > 0)?'Yes':false;

            const filters = Object.keys(selectedFilter).reduce(function(acc, val) {
                if(selectedFilter[val] !== 'Select')  acc[val] = selectedFilter[val];
              return acc;
            }, {});

            const hasFilter = (Object.keys(filters).length > 0)?'Yes':false;


            svgVillagerNode
                 .attr('class', (d) => {
                   const isSelected = (filteredList)?filteredList.some(v => v.name ===  d.name):false;
                   return `dot ${(isSelected&&hasFilter)?'active':''}`
                 })
                 .style("stroke-width", 2)
                 .attr('r', (d) => {
                   const isSelected = (filteredList)?filteredList.some(v => v.name ===  d.name):false;
                   let r = (isSelected&&hasFilter)?radius*5:radius;
                   return r
                 })
                 .style("stroke", 'none')
                 .attr('fill', (d) => {
                   const isSelected = (filteredList)?filteredList.some(v => v.name ===  d.name):false;
                   let imageName = d.name;
                   imageName = (imageName.indexOf(' ') >= 0)?imageName.replace(/ /g,"-"):imageName;

                   imageName = imageName.replace(/["']/g, "")

                   let f = (isSelected&&hasFilter)?`url(#v-profile-${imageName})`:acnhColors.themeColor;
                   return f
                 });

           this.simulation.on('tick', () => {
              svgVillagerNode
                  .attr("cx", d => d.x)
                  .attr("cy", d => d.y)
                  .transition()
                  .duration(2000);
            })

   }
   updateChart(filteredList){
     const {selectedFilter} = this.state;
     let svg = this.svg,
         allVillagers = this.allVillagers,
         tierHeight = 70,
         chartWidth = this.state.chartWidth;

     let radius = 4;

         // Node Position
         let tierPerRow = 1,
             tierRowWidth = chartWidth / (tierPerRow + 1);

         this.allVillagerNodes = allVillagers.sort((a,b)=>a.tier-b.tier).reduce((obj, villager, i) => {
             let uniqueCount = Object.keys(obj).length;
             if (obj[villager.tier]){
                 ++obj[villager.tier].count;
             } else {
               obj[villager.tier] = {
                 id: i+1,
                 tier: villager.tier,
                 count: 1,
                 x: (uniqueCount % tierPerRow + 1) * tierRowWidth*1,
                 y: (Math.floor(uniqueCount / tierPerRow) + 1) * (tierHeight + tierHeight * 0.05),
               };
               uniqueCount++
             }
            return obj;
          }, {});

          //assign position
          allVillagers.forEach((villager) => {
             let tierNode = this.allVillagerNodes[villager.tier];
             villager.summaryX = tierNode.x;
             villager.summaryY = tierNode.y;
           });


       let svgVillagerNode = svg.selectAll('.dot');

       ///const hasFilter = (Object.keys(filters).length > 0)?'Yes':false;

       const filters = Object.keys(selectedFilter).reduce(function(acc, val) {
           if(selectedFilter[val] !== 'Select')  acc[val] = selectedFilter[val];
         return acc;
       }, {});

       const hasFilter = (Object.keys(filters).length > 0)?'Yes':false;


       svgVillagerNode.data(allVillagers)
            .join("circle")
            //.classed(`${dotClass}`, true)
            .attr('class', (d) => {
              const isSelected = (filteredList)?filteredList.some(v => v.name ===  d.name):false;
              return `dot ${(isSelected&&hasFilter)?'active':''}`
            })
            .style("stroke-width", 2)
            .attr('r', (d) => {
              const isSelected = (filteredList)?filteredList.some(v => v.name ===  d.name):false;
              let r = (isSelected&&hasFilter)?radius*5:radius;
              return r
            })
            .style("stroke", 'none')
            .attr('fill', (d) => {
              const isSelected = (filteredList)?filteredList.some(v => v.name ===  d.name):false;
              let imageName = d.name;
              imageName = (imageName.indexOf(' ') >= 0)?imageName.replace(/ /g,"-"):imageName;
              imageName = imageName.replace(/["']/g, "")
              let f = (isSelected&&hasFilter)?`url(#v-profile-${imageName})`:acnhColors.themeColor;
              return f
            });


       this.simulation.on('tick', () => {
          svg.selectAll('.dot')
              .attr("cx", d => d.x)
              .attr("cy", d => d.y)
              .transition()
              .duration(2000);
        })

       this.simulation.nodes(allVillagers)
                     .force('x', d3.forceX().x(d => d.summaryX).strength(0.04))
                     .force('y', d3.forceY().y(d => d.summaryY).strength(10))
                     //.force('forceX', d3.forceX(d => yScale(d.tier)/2).strength(1))
                     //.force('forceY', d3.forceY(d => yScale(d.tier)).strength(1))
                     .force('collide', d3.forceCollide()
                                         .radius(
                                           d => {
                                             return radius*3
                                             //return (hasFilter)?radius*3.5:radius*1.5
                                           }
                                         )
                                         .strength(1))
                     .alpha(1)
                     .velocityDecay(0.4)
                     .alphaMin(0.004)
                     .restart();

   }

   drawSummaryChart() {
     // init plot
     this.simulation.stop();

     let svg = this.svg,
         allVillagers = this.allVillagers,
         tierHeight = 70,
         chartWidth = this.state.chartWidth;

    let chartHeight = tierHeight * (this.tierArray.length + 1)

     svg.attr("height", chartHeight);

     const yScale = d3.scaleBand()
           .domain(this.tierArray)
           .range([0, chartHeight])


     const yAxis = g => g
               .attr("transform", `translate(${56},${tierHeight * 0.3})`)
               .call(d3.axisLeft(yScale).tickFormat(function(d,i){ return `Tier ${d}` }).tickSizeOuter(0))
               .call(g => g.selectAll(".domain").remove())

     svg.append("g")
     .attr("class", 'yaxis tier-axis no-tick')
     .call(yAxis);


   }


   onFilterChange(filterLabel, newValue, filterType) {
    const { filterList, filteredList, selectedFilter} = this.state;

    const newSelectedFilter = selectedFilter;

    if (selectedFilter[filterLabel] === 'Select') {
      newSelectedFilter[filterLabel] = newValue;
    } else {
      if(filterType === 'checkbox'){
        newSelectedFilter[filterLabel] = 'Select';
      }else{
        newSelectedFilter[filterLabel] = newValue;
      }

    }

    const filters = Object.keys(newSelectedFilter).reduce(function(acc, val) {
        if(newSelectedFilter[val] !== 'Select')  acc[val] = newSelectedFilter[val];
      return acc;
    }, {});

    const hasFilter = (Object.keys(filters).length > 0)?'Yes':false;

    let getFilteredList = () => {
        //const apperanceScoreFilter = d => (d.Apperance_Score === selectApperanceScore) || (selectApperanceScore === 'all')
        let list = this.allVillagers;
        if(hasFilter){
          let filtersObj = filterList.reduce((o, key) => ({ ...o, [key.datalabel]:((newSelectedFilter[key.label] !== 'Select')? newSelectedFilter[key.label]:'')}), {});

          filtersObj = Object.keys(filtersObj).reduce((p, c) => {
             if (filtersObj[c]) p[c] = filtersObj[c];
             return p;
           }, {});

          const selectedFilterKeys = Object.keys(filtersObj)

          const filteredVillagers = list.filter(v => selectedFilterKeys.every(key => {
            let vKey = v[key];
            if(key === 'Apperance_Score'){
              vKey = goodlookingScores[v[key]];
            }
            return filtersObj[key] === vKey
          }))

          return filteredVillagers

        }else{
          return list
        }
     }

    this.setState({ filteredList: [...getFilteredList()] });

    this.setState({ selectedFilter: newSelectedFilter });

    //this.updateChart([...getFilteredList()]);

  }

  clearFilter(){
    const {selectedFilter} = this.state;

    let newSelectedFilter = selectedFilter;

    newSelectedFilter = Object.keys(newSelectedFilter).reduce((acc, key) => {acc[key] = 'Select'; return acc; }, {})

    this.setState({ filteredList: this.allVillagers });

    this.setState({ selectedFilter: newSelectedFilter });
  }

  showCard(e, villager){
    e.preventDefault();
    let ePosition =  e.target.getBoundingClientRect(),
        cardSize = 240,
        circleSize = 20,
        vWidth = window.innerWidth,
        vHeight = window.innerHeight;

    let lPosition = ePosition.left,
        tPosition = ePosition.top,
        scrollY = window.scrollY + ePosition.top,
        skinColor = (villager.skin_color === 'ffffff')?`#C2DEE0`:`#${villager.skin_color}`;

    //let x = window.scrollX + ePosition.left;

    let y = ((vHeight-tPosition) <=300)? (scrollY - cardSize + circleSize) : scrollY;
    //let x = lPosition - cardSize;
    let x = (lPosition <=300)?(lPosition + circleSize):(lPosition - cardSize);

    let bgColor = tinycolor(skinColor);


    this.setState({
      selectedVillager:villager,
      cardStyle: {
        backgroundColor: bgColor.desaturate(5).lighten(15).toString(),
        top:y,
        left:x,
      }
    })

  }

  hideCard(e, villager){
    e.preventDefault();
    this.setState({
      selectedVillager:''
    })

  }

  toggleFilter(filterType){
    let newFilterType;
    if(filterType === "positive"){
        newFilterType = "positive"
    }else{
        newFilterType = "negative"
    }
    this.clearFilter();
    this.setState({
      filterType : newFilterType
    })
  }

    enterEnd = () =>{
      const el = document.querySelector(`#summary-chart-filter`)
      el.classList.add("active");
    }

    leaveEnd = () =>{
      const el = document.querySelector(`#summary-chart-filter`)
      el.classList.remove("active");
    }


  render() {
    const { filterList, filteredList, selectedFilter} = this.state;

    const filters = Object.keys(selectedFilter).reduce(function(acc, val) {
        if(selectedFilter[val] !== 'Select')  acc[val] = selectedFilter[val];
      return acc;
    }, {});

    const hasFilter = (Object.keys(filters).length > 0)?'Yes':false;

    //filter toggle
    const btnList = [
        {
            id: 1,
            label: 'Positive trend',
            functionParams: "positive",
            isSelected: false,
        },
        {
            id: 2,
            label: 'Negative trend',
            functionParams: "negative",
            isSelected: false,
        }
    ];

    return (

      <section ref={this.props.innerRef}  id="section-summary">
        <h2 className="title">Putting It All Together</h2>
        <p className="paragraph">We now have the set of “significant attributes” that we believe define a villager’s popularity. But we’ve been looking at each attribute individually. How do these attributes relate to each other? Is a good looking cat more popular than a good looking gorilla? </p>

          <TipBubble>Filter by one or more attribute and see where the villagers with those attributes rank. Highlighted villagers will appear as dark green dots. </TipBubble>
        <div id="summary-chart" className=" space-bottom">

          <div id="summary-chart-filter" className="filter-container">
            <div className="btn-group filter-toggle" role="group">
              {btnList.map(btn => (
                  <Button
                      key={btn.id}
                      btnType="button"
                      classList={`toggle ${this.state.filterType === btn.functionParams ? 'active' : ''}`}
                      btnClick={(e) => this.toggleFilter(btn.functionParams, e)}
                  >
                      {btn.label}
                  </Button>
              ))}
             </div>

            {this.state.filterType === 'positive'
              ? <p className="paragraph">Attributes with the strongest <b>positive</b> correlation to popularity.</p>
              : <p className="paragraph">Attributes with the strongest <b>negative</b> correlation to popularity.</p>
            }

             <form>
              {this.state.filterList.filter(f =>f.trend === this.state.filterType).map(filter => (
                 <React.Fragment key={filter.id}>
                    {(() => {
                      switch (filter.type) {
                        case 'checkbox':
                          let newValue = (selectedFilter[filter.label] === 'Select')?filter.options[0]:'Select';
                          return <div className='checkbox'>
                                    <input
                                    id={`filter-${filter.label}`}
                                    type="checkbox"
                                    checked={selectedFilter[filter.label] !== 'Select'}
                                    onChange={() => this.onFilterChange(filter.label, newValue,filter.type)}
                                    />
                                    <label htmlFor={`filter-${filter.label}`}>{filter.name}</label>
                                </div>
                        case 'dropdown':
                          return <div className={`select-dropdown ${(selectedFilter[filter.label] !== 'Select')?'active':''}`}>
                                  <label htmlFor={`filter-${filter.label}`}>{filter.name}</label>
                                  <select
                                    id={`filter-${filter.label}`}
                                    name={`filter-${filter.label}`}
                                    onChange={(e) => this.onFilterChange(filter.label, e.target.value,filter.type)} >
                                      {filter.options.map((item,index) => (
                                        <option key={index} value={item}>
                                          {(item === 'Select')? `${item} ${filter.name}`:item}
                                        </option>
                                      ))}
                                   </select>
                                 </div>
                        default:
                          return null;
                      }
                    })()}
                </React.Fragment>
              ))}
              </form>
          </div>
          {/*<svg ref={this.svgRef} width={this.props.chartWidth}></svg>*/}
          {this.state.selectedVillager !== '' &&
            <VillagerCard villager={this.state.selectedVillager} style={this.state.cardStyle}/>
          }
          <div className="v-list-container">
              <ol className={`villager-list`}>
              {
                this.allVillagers.map(d => {
                    let isSelected = filteredList.some(v => v.name ===  d.name);
                    return (
                      <li key={d.id} className={`tier-list-villager ${(isSelected&&hasFilter)?'active':''}`} onMouseEnter={(e) => this.showCard(e,d)} onMouseLeave={(e) => this.hideCard(e, d)}>
                        <img className='villager-profile-img' alt={`Profile photo of ${d.name}`} src={`${process.env.PUBLIC_URL}/images/face/face-image-${d.id}.png`}/>
                      </li>
                    )
                })
               }
              </ol>

          </div>

        </div>

      </section>
    )
  }
}

export default VoteEnd;
